import { useState } from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { SEDI, CONTACT } from "../data/site";
import { QuoteForm } from "./QuoteForm";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./motion";

const Info = () => (
  <div className="grid gap-8 sm:grid-cols-2">
    <div>
      <p className="eyebrow mb-3 flex items-center gap-2 text-[color:var(--ngp-teal-ink)]"><Phone size={14} aria-hidden="true" />Telefono</p>
      <a href={CONTACT.phoneMainHref} className="link-underline block text-lg font-medium" data-testid="contact-phone-main">{CONTACT.phoneMain}</a>
      <a href={CONTACT.phoneMobileHref} className="link-underline block text-lg font-medium" data-testid="contact-phone-mobile">{CONTACT.phoneMobile}</a>
    </div>
    <div>
      <p className="eyebrow mb-3 flex items-center gap-2 text-[color:var(--ngp-teal-ink)]"><Mail size={14} aria-hidden="true" />Email</p>
      {CONTACT.emails.map((m) => <a key={m} href={`mailto:${m}`} className="link-underline block text-lg font-medium" data-testid={`contact-email-${m.split("@")[0]}`}>{m}</a>)}
    </div>
  </div>
);

const Maps = () => {
  const [active, setActive] = useState(0);
  return (
    <div>
      <div role="tablist" aria-label="Sedi" className="flex gap-2">
        {SEDI.map((s, i) => (
          <button key={s.city} role="tab" aria-selected={active === i} onClick={() => setActive(i)} data-testid={`map-tab-${s.city.toLowerCase()}`}
            className={`flex-1 rounded-[var(--ngp-radius)] border p-4 text-left transition-colors duration-300 ${active === i ? "border-[color:var(--ngp-ink)] bg-[color:var(--ngp-ink)] text-white" : "border-[color:var(--ngp-line)] bg-white hover:border-[color:var(--ngp-ink)]"}`}>
            <span className="eyebrow flex items-center gap-1.5"><MapPin size={13} aria-hidden="true" />Sede {s.city}</span>
            <span className="mt-2 block text-sm">{s.address}<br />{s.cap}</span>
          </button>
        ))}
      </div>
      <div className="mt-3 aspect-[4/3] overflow-hidden rounded-[var(--ngp-radius)] border border-[color:var(--ngp-line)] bg-[#e5e5e0] grayscale-[0.6] transition-[filter] duration-500 hover:grayscale-0">
        <iframe key={active} title={`Mappa sede ${SEDI[active].city}`} src={SEDI[active].map} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="h-full w-full border-0" data-testid="contact-map" data-lenis-prevent />
      </div>
    </div>
  );
};

export const ContactSection = ({ withHead = true }) => (
  <section id="contatti" data-testid="contact-section" className="scroll-mt-24 bg-[color:var(--ngp-paper)]">
    <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-36">
      {withHead && <SectionHead index="06" eyebrow="Contatti" lines={["Richiedi un", "preventivo."]} text="Compila il modulo: ti rispondiamo con una proposta chiara su costi e tempi." />}
      <div id="preventivo" className={`grid scroll-mt-28 gap-14 lg:grid-cols-12 lg:gap-16 ${withHead ? "mt-14 lg:mt-20" : ""}`}>
        <Reveal className="rounded-[var(--ngp-radius)] bg-white p-6 shadow-[0_40px_100px_-60px_rgba(0,0,0,.4)] sm:p-10 lg:col-span-7"><QuoteForm /></Reveal>
        <Reveal delay={0.15} className="flex flex-col gap-10 lg:col-span-5"><Info /><Maps /></Reveal>
      </div>
    </div>
  </section>
);
